/**
 * 接口列表
 */
const { port } = document.location;
let hostUrl = 'http://';

if (port === 80) {
    hostUrl += document.location.hostname;
} else {
    hostUrl += document.location.host;
}

// export const URL = hostUrl;
// export const BASE_URL = process.env.VUE_APP_API_BASE_URL;
// // export const BASE_URL = 'http://192.168.168.249:8090';
export const BASE_URL = `${hostUrl}`;
// export const BASE_URL = process.env.VUE_APP_API_BASE_URL;

// export const BASE_URL = hostUrl;

// 登录
export const GET_USERINFO = `${BASE_URL}/login?cmd=sso-login`;
export const GET_AUTH = `${BASE_URL}/token`;
export const GET_SELF_USERINFO = `${BASE_URL}/login?cmd=self-login`;
export const GET_SELF_SSO_USERINFO = `${BASE_URL}/system?cmd=simplessologin`;
//  搜索
export const SEARCH_LIST_ISLOGIN = `${BASE_URL}/media?cmd=searchByParams&publish=1`;

// 未登录
// 未登录时视频列表
export const VIODE_LIST_ISLOGIN = `${BASE_URL}/anonymous?cmd=media`;
// 未登录推荐
export const GET_RECOMENTED_ISLIST = `${BASE_URL}/anonymous?cmd=media`;
// 未登录直播
export const GET_LIVE_ISLIST = `${BASE_URL}/anonymous/meeting`;

// 未登录分类
export const GET_CHANNEL_ISLIST = `${BASE_URL}/anonymous/channel`;

export const ADD_VIDEO_ISVIEW = `${BASE_URL}/anonymous/media/view`;
export const BANNER_ISVIEW = `${BASE_URL}/banner?cmd=list`;

export const ADD_VIDEO_VIEW = `${BASE_URL}/media?cmd=views`;

export const ADD_VIDEO_DOWNLOAD = `${BASE_URL}/media?cmd=download`;

// 登录视频详情
export const GET_VIDEO_DETAIL = `${BASE_URL}/media?cmd=detail`;
// 登录视频列表
export const VIODE_LIST_LOGIN = `${BASE_URL}/media?cmd=searchByParams&publish=1`;
// 登录直播
export const GET_LIVE_LIST = `${BASE_URL}/media?cmd=orgMeeting`;


// 登录推荐
export const GET_RECOMENTED_LIST = `${BASE_URL}/media?cmd=searchByParams&publish=1`;

// 登录分类
export const GET_CHANNEL_LIST = `${BASE_URL}/media?cmd=getchannels`;

export const BANNER_LIST = `${BASE_URL}/banner?cmd=list`;
// 收藏列表
export const GET_COLLECT_LIST = `${BASE_URL}/media?cmd=collection`;
// 收藏更新
export const UPDATA_COLLECT_LIST = `${BASE_URL}/media?cmd=collection`;


// 点赞列表
export const GET_LIKE_LIST = `${BASE_URL}/media?cmd=like`;
// 点赞更新
export const UPDATA_LIKE_LIST = `${BASE_URL}/like`;

export const VIDEO_DTAIL = `${BASE_URL}/v1/program`;
// 评论
export const GET_COMMENT_LIST = `${BASE_URL}/comment?cmd=search`;
export const RESOLVE_COMMENT = `${BASE_URL}/comments/:id`;
export const BULK_COMMENT_DELETE = `${BASE_URL}/comments`;
export const ADD_COMMEN = `${BASE_URL}/comment?cmd=add`;

// 附件
export const GET_FILELIST = `${BASE_URL}/media?cmd=getAttachments`;

export const MEETINGVIEW = `${BASE_URL}/meeting?cmd=view`;

export const VIEWCOUNT = `${BASE_URL}/meeting?cmd=viewcount`;